// AI对话工具
const aiTwo = [
  {
      "name": "ChatGPT",
      "url": "https://openai.com/",
      "icon": "https://openai.com/favicon.ico",
      "description": "由OpenAI开发的通用型对话式AI，支持多轮对话、内容生成（如文章、代码、诗歌等）、问题解答、语言翻译等，广泛应用于创意写作、教育辅导、客服支持等场景。"
  },
  {
      "name": "豆包MarsCode",
      "url": "https://www.marscode.cn/",
      "icon": "https://lf-cdn.marscode.cn/obj/marscode-bucket-cn/marscode-favicon.ico",
      "description": "专注于代码辅助的AI工具，提供代码生成、漏洞检测、智能补全、算法优化等功能，支持多种编程语言，主要服务于开发者和技术团队，提升编码效率与代码质量。"
  },
  {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com",
      "icon": "images/deepseek.png",
      "description": "深度求索推出的高性能AI模型，擅长数学推理、逻辑分析和专业领域知识问答，适用于科研辅助、金融数据分析、教育测评等对精准计算和复杂逻辑处理有需求的场景。"
  },
  {
      "name": "通义灵码",
      "url": "https://tongyi.aliyun.com/lingma/",
      "icon": "https://img.alicdn.com/imgextra/i4/O1CN01EfJVFQ1uZPd7W4W6i_!!6000000006051-2-tps-112-112.png",
      "description": "阿里云通义千问旗下的代码生成工具，支持根据自然语言描述生成可运行的代码片段，覆盖多语言开发框架，主要用于快速原型开发、脚本编写和编程教学。"
  },
  {
      "name": "讯飞星火",
      "url": "https://xinghuo.xfyun.cn",
      "icon": "https://xinghuo.xfyun.cn/favicon.ico",
      "description": "科大讯飞开发的认知智能平台，具备文本生成、语言理解、多模态交互等能力，广泛应用于智能客服、教育学习、办公辅助（如文档生成、会议纪要）等场景。"
  },
  {
      "name": "文心一言",
      "url": "https://yiyan.baidu.com",
      "icon": "images/wxyy.png",
      "description": "百度推出的中文语境通用AI，支持对话交互、内容创作（如故事、营销文案）、知识问答、图像生成等，特别针对中文用户的语言习惯和文化背景优化，适用于内容创作、信息查询等场景。"
  },
  {
      "name": "Kimi",
      "url": "https://kimi.moonshot.cn/",
      "icon": "https://kimi.moonshot.cn/favicon.ico",
      "description": "专注于长文本处理的AI工具，支持超长文本解析、信息提取、摘要生成和跨文档知识关联，主要用于学术研究、法律文档分析、数据分析报告生成等场景。"
  },
  {
      "name": "CodeGeeX",
      "url": "https://codegeex.cn/",
      "icon": "https://codegeex.cn/assets/images/only_logo_dark.png",
      "description": "面向开发者的代码智能助手，提供代码补全、函数注释生成、代码翻译（多语言转换）等功能，支持主流IDE集成，提升编程效率，降低开发门槛。"
  },
  {
      "name": "Jasper",
      "url": "https://www.jasper.ai/",
      "icon": "https://cdn.prod.website-files.com/60e5f2de011b86acebc30db7/665dd9c1792c38c09c7d74ec_Jasper%20Logo%20Lockup%20-%20Dark%20Khaki.svg",
      "description": "全球领先的AI内容生成平台，专注于营销文案、电商产品描述、社交媒体内容创作，支持多语言和多场景模板，帮助企业和个人快速产出高质量的营销内容。",
      isVpn: true
  },
  {
      "name": "跃问",
      "url": "https://yuewen.cn/",
      "icon": "https://yuewen.cn/svg/favicon.svg",
      "description": "聚焦于专业领域的知识问答AI，支持行业报告解读、政策法规查询、技术文档解析等，主要服务于金融、法律、医疗等需要精准专业知识支持的场景。"
  },
  {
      "name": "Poe",
      "url": "https://poe.com/",
      "icon": "images/poe.jpg",
      "description": "由Quora推出的AI问答平台，整合多个AI模型（如GPT-4、Claude等），支持实时问答、观点讨论和知识分享，用户可通过自然语言提问获取多源AI的综合解答。"
  },
  {
      "name": "JanitorAI",
      "url": "https://janitorai.com",
      "icon": "images/janitorai.jpg",
      "description": "主打轻量化交互的AI助手，支持日常对话、任务提醒、信息查询等功能，界面简洁易用，适合普通用户进行日常沟通和生活助手类需求。"
  },
  {
      "name": "SpicyChat",
      "url": "https://spicy.chat",
      "icon": "images/SpicyChat.jpg",
      "description": "专注于创意对话和趣味交互的AI，支持角色扮演、故事续写、幽默聊天等功能，主要用于娱乐场景和个性化社交互动。"
  },
  {
      "name": "CrushOn.AI",
      "url": "https://crushon.ai",
      "icon": "images/crushon.jpg",
      "description": "主打情感陪伴和个性化交流的AI伴侣，通过自然语言对话模拟人类情感，提供情感支持、兴趣聊天等功能，适用于孤独感缓解和陪伴需求。"
  },
  {
      "name": "Candy AI",
      "url": "https://candy.ai/",
      "icon": "images/candy.png",
      "description": "面向年轻用户的轻量化AI助手，支持表情包生成、趣味测试、社交内容建议等功能，主打轻松娱乐和社交互动场景。"
  },
  {
      "name": "MaxAI.me",
      "url": "https://www.maxai.co/",
      "icon": "images/maxai.jpg",
      "description": "聚焦于多模态交互的AI工具，支持文本、语音、图像输入输出，提供智能创作（如海报设计、短视频脚本）、实时翻译等功能，适用于创意设计和跨语言沟通场景。"
  },
  {
      "name": "ZeroGPT",
      "url": "https://www.zerogpt.com",
      "icon": "https://www.zerogpt.com/favicon.ico",
      "description": "专注于AI内容检测的工具，用于识别文本是否由GPT等AI生成，支持学术论文、作业、稿件的原创性检测，帮助用户判断内容的人工或AI生成属性。"
  },
  {
      "name": "Phind",
      "url": "https://www.phind.com",
      "icon": "https://www.phind.com/favicon.ico",
      "description": "面向开发者的AI代码搜索与问题解答工具，支持根据代码片段或自然语言查询快速定位解决方案，整合代码库和技术文档，提升开发效率。"
  },
  {
      "name": "Pi",
      "url": "https://pi.ai",
      "icon": "images/pi.jpg",
      "description": "主打个性化学习的AI助手，支持知识图谱构建、学习计划制定、错题解析等功能，主要用于学生群体的课程辅导和自主学习场景。",
      isVpn: true
  },
  {
      "name": "Chub Venus AI",
      "url": "https://chub.ai/",
      "icon": "images/chub.png",
      "description": "专注于多语言翻译和文化交流的AI工具，支持实时语音翻译、跨语言对话优化，适用于国际商务沟通、旅行翻译等跨文化场景。",
      isVpn: true
  },
  {
      "name": "Gemini",
      "url": "https://ai.google.com",
      "icon": "images/maxai.jpg",
      "description": "谷歌推出的多模态AI模型，支持文本、图像、视频、语音等多种输入输出形式，具备复杂推理和创意生成能力，应用场景涵盖内容创作、教育、科研等多个领域。"
  },
  {
      "name": "豆包",
      "url": "https://doubao.com",
      "icon": "images/doubao.png",
      "description": "字节跳动开发的通用型AI助手，支持智能问答、生活服务（如天气查询、日程管理）、内容创作等功能，主打轻量化交互和日常实用场景。"
  },
  {
      "name": "腾讯元宝",
      "url": "https://yuanbao.tencent.com/chat/naQivTmsDa",
      "icon": "images/yuanbao.webp",
      "description": "腾讯推出的AI金融助手，专注于投资理财、风险评估、金融知识普及等功能，为用户提供个性化的金融服务建议和市场分析。"
  },
  {
      "name": "Bing Copilop",
      "url": "https://www.bing.com/copilot",
      "icon": "https://www.bing.com/favicon.ico",
      "description": "微软必应推出的AI辅助工具，整合搜索引擎和生成式AI，支持网页内容总结、实时信息检索、创意灵感生成，主要用于信息查询和内容创作辅助。"
  },
  {
      "name": "Devv AI",
      "url": "https://devv.ai",
      "icon": "images/devv-ai.jpg",
      "description": "专注于开发者工具链的AI平台，提供代码调试、性能优化、技术方案设计等功能，支持全栈开发流程，提升团队协作效率。"
  },
  {
      "name": "Grok AI",
      "url": "https://x.ai/grok",
      "icon": "images/grok.png",
      "description": "由马斯克的xAI开发的AI模型，主打逻辑推理和事实挖掘，支持复杂问题解答和深度数据分析，适用于科研、工程等需要精准逻辑处理的场景。",
      isVpn: true
  },
  {
      "name": "知乎直答",
      "url": "https://www.zhihu.com/zhi答",
      "icon": "https://www.zhihu.com/favicon.ico",
      "description": "知乎推出的知识问答AI，整合平台海量优质内容，支持专业领域深度解答、热点话题分析，主要用于知识获取和深度思考辅助。"
  },
  // {
  //     "name": "百小应",
  //     "url": "https://xiaoying.baidu.com",
  //     "icon": "https://xiaoying.baidu.com/favicon.ico",
  //     "description": "百度旗下的轻量化AI助手，支持语音交互、生活服务（如外卖预订、快递查询）、学习辅助等功能，主打便捷的日常生活场景。"
  // },
  {
      "name": "天工AI",
      "url": "https://www.tiangong.cn/",
      "icon": "images/tiangong.png",
      "description": "360公司推出的AI安全助手，专注于网络安全检测、漏洞扫描、数据加密等功能，为企业和个人提供智能化的安全防护解决方案。"
  },
  {
      "name": "YouChat",
      "url": "https://you.com",
      "icon": "images/you.png",
      "description": "面向全球用户的跨平台AI聊天工具，支持多语言实时翻译、群组对话管理，适用于国际社交和团队协作场景。"
  },
  // {
  //     "name": "书生",
  //     "url": "https://shusheng.ai",
  //     "icon": "images/shusheng.png",
  //     "description": "中科院研发的中文语言处理AI，专注于古籍整理、文言文解析、传统文化知识问答，主要应用于学术研究和文化传承领域。"
  // },
  {
      "name": "Felo",
      "url": "https://felo.ai",
      "icon": "https://felo.ai/favicon.ico",
      "description": "聚焦于心理健康的AI助手，提供情绪疏导、压力管理、心理测评等功能，通过对话模拟人类共情，帮助用户缓解焦虑和情绪问题。"
  },
  {
      "name": "新必应",
      "url": "https://www.bing.com/",
      "icon": "https://www.bing.com/favicon.ico",
      "description": "微软升级后的智能搜索引擎，整合GPT-4等AI技术，支持自然语言提问、实时信息检索、内容生成（如旅游攻略、购物建议），提供更智能的搜索体验。"
  },
  // {
  //     "name": "智谱清言",
  //     "url": "https://zhipu.ai",
  //     "icon": "images/zhipu.jpg",
  //     "description": "智谱AI推出的学术型AI，支持论文摘要生成、文献综述、研究问题解答，主要服务于科研人员和高校学生的学术研究场景。"
  // },
  {
      "name": "Anthropic",
      "url": "https://www.anthropic.com/",
      "icon": "https://www.anthropic.com/favicon.ico",
      "description": "由前OpenAI团队创立的AI公司，主打安全可控的AI模型，支持复杂任务分解、逻辑推理，主要应用于企业级解决方案和高可靠性要求场景。"
  },
  {
      "name": "问小白",
      "url": "https://wenxiaobai.com",
      "icon": "https://www.wenxiaobai.com/_next/image?url=%2FchatList%2Fcolorlogo.png&w=96&q=75",
      "description": "面向初学者的知识普及AI，支持基础概念解析、学习路径规划、问题答疑，主要用于中小学教育和技能入门辅导场景。"
  }
]

export default aiTwo
